import { NewInboxManualTasksEnabledDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

export const useManualTasksEnabled = () => {
  const { company } = useCurrentSession()

  const { data, loading } = useQuery(NewInboxManualTasksEnabledDocument, {
    variables: { companyId: company.id },
  })

  const enabled = !!data?.features?.featuresConnection?.totalCount

  const isLoading = !data && loading

  return { enabled, isLoading }
}
